import React, { useState, useEffect } from "react";
import { useLazyGetPackingListSearhQuery, useLazyGetSavedPackingListQuery } from "../../services/Api";
import { toast } from "react-toastify";
import CardsSection from "../packingList/cardsSection";
import { banner_packing_filter } from "../../assets/updated_assests/assets";
import CardGridSkelton from "../../components/skelton/cardSkelton";

const UserSavedPackingList = () => {
    const [showLisitn, setShowListing] = useState(false);
    const [page, setPage] = useState(1)
    const [filters, setFilters] = useState({})
    const [pagination, setPagination] = useState(0)

    const [triggerSaved, { data: savedPacking, isLoading: loading, isError: saveListError }] = useLazyGetSavedPackingListQuery();



    useEffect(() => {
        triggerSaved()
    }, []);


    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    }, [showLisitn]);

    return (
        <div className="min-h-[100vh]">
            <div>
                <div className="banner min-h-[700px] w-full !bg-cover !bg-no-repeat text-center" style={{
                    background: `url(${banner_packing_filter})`,

                }} >
                    <div className="grid bg-[#25231B80] md:grid-cols-5  grid-cols-1 min-h-[700px]">
                        <div className=" w-full min-h-[700px] flex col-span-2 justify-center items-end p-4 md:pl-12">
                            <div className="">
                                <h3 className='text-white text-left font-roboto-mono font-bold italic md:text-[2.5rem] text-[1.8rem]' >
                                    Find Your Perfect Packing match
                                </h3>
                                <p className='text-white font-quicksand font-medium text-[16px] text-left ' >Explore our curated packing list options tailored to your travel needs. Choose your perfect fit and enjoy a seamless packing experience with the Westbreeze Packing System!</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            {loading ? <>
                <CardGridSkelton />
            </> :
                <CardsSection data={savedPacking} showSaved={true} page={page} setPage={setPage} setPagination={setPagination} />
            }
        </div>
    );
};

export default UserSavedPackingList;
